// extracted by mini-css-extract-plugin
export default {"mainDiv":"resetPasswordSuccess_mainDiv__IyKvo","subDiv":"resetPasswordSuccess_subDiv__p0A4J","buttonDefault":"resetPasswordSuccess_buttonDefault__ZJaqQ"};